import { useEffect } from "react";
import useLogout from "./hooks/useLogout";

const Logout = () => {
  const { logout } = useLogout();
  useEffect(() => {
    logout();
    // eslint-disable-next-line
  }, []);

  return <div>Redireccionado...</div>;
};

export default Logout;
